export default __webpack_public_path__ + "static/media/illustration-algocare-m.824ea513.webp";